import React from "react";
import { UseFormReturn } from "react-hook-form";
import { SectionTitle } from "../../../components/Checkout/SectionTitle";
import { ControlledTextField } from "../../../components/forms/ControlledTextField";
import { CHECKOUT_MAXLEN } from "../../../utils/checkoutFieldMaxLengths";
import { ActualizacionDatosFormValues } from "../ActualizacionDatosTypes";

interface ContactoSeccionProps {
    methods: UseFormReturn<ActualizacionDatosFormValues>;
}

export const ContactoSeccion: React.FC<ContactoSeccionProps> = ({ methods }) => (
    <>
        <SectionTitle>Datos de contacto</SectionTitle>

        <ControlledTextField
            control={methods.control}
            label="E-mail"
            name="datosPersonales.mail"
            required
            inputProps={{ maxLength: CHECKOUT_MAXLEN.vchMail }}
        />
    </>
);
